import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="login-container">
      <div class="glow-orb orb-1"></div>
      <div class="glow-orb orb-2"></div>
      
      <div class="login-card glass">
        <div class="logo">
          <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" stroke-width="2" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
          <h1>Sorrus</h1>
        </div>
        
        <ng-container *ngIf="mode === 'login'">
          <p class="subtitle" *ngIf="!guid">Geben Sie Ihren Organisationstoken ein.</p>
          <p class="subtitle" *ngIf="guid">Willkommen zurück! Bitte verifizieren Sie sich.</p>
          
          <div class="input-group">
            <input [(ngModel)]="guid" 
                   type="password" 
                   placeholder="Organisationstoken (GUID)" 
                   class="modern-input">
          </div>

          <div class="fade-in" *ngIf="guid">
            <div class="input-group">
              <input [(ngModel)]="email" 
                     type="email" 
                     placeholder="E-Mail Adresse" 
                     class="modern-input">
            </div>

          </div>
          
          <div class="error-msg" *ngIf="error">{{ error }}</div>
          
          <button class="btn-primary" (click)="onLogin()">
            Anmelden
          </button>

          <div class="divider"><span>ODER</span></div>

          <button class="btn-secondary" (click)="mode = 'join'">
            Organisation folgen
          </button>
        </ng-container>

        <ng-container *ngIf="mode === 'join'">
          <p class="subtitle">Tritt einer Organisation bei oder erstelle eine neue.</p>
          
          <div class="input-group" *ngIf="!qrCode && !joinSuccess">
            <input [(ngModel)]="joinEmail" 
                   type="email" 
                   placeholder="Ihre E-Mail" 
                   class="modern-input">
            <input [(ngModel)]="joinToken" 
                   type="password" 
                   placeholder="Organisationstoken" 
                   class="modern-input" style="margin-top: 10px;">
            <button class="btn-primary" style="margin-top: 20px;" (click)="onJoin()" [disabled]="loading">
              {{ loading ? 'Verarbeite...' : '2FA einrichten' }}
            </button>
          </div>

          <div class="setup-2fa" *ngIf="qrCode">
            <p style="color: white; font-size: 0.9rem; margin-bottom: 1rem;">Scanne diesen QR-Code mit einer Authenticator App:</p>
            <div class="qr-container">
              <img [src]="qrCode" class="qr-img">
            </div>
            <input [(ngModel)]="joinCode" 
                   type="text" 
                   placeholder="Aktueller 2FA Code" 
                   class="modern-input" style="margin-top: 1.5rem;">
            <button class="btn-primary" style="margin-top: 1rem;" (click)="onVerifyJoin()" [disabled]="loading">
              Beitritt bestätigen
            </button>
          </div>

          <div class="success-msg" *ngIf="joinSuccess">
            {{ joinSuccess }}
          </div>

          <div class="error-msg" *ngIf="error">{{ error }}</div>

          <button class="btn-text" (click)="mode = 'login'" *ngIf="!joinSuccess">
            Zurück zum Login
          </button>
          <button class="btn-primary" (click)="mode = 'login'" *ngIf="joinSuccess" style="margin-top: 1rem;">
            Jetzt Anmelden
          </button>
        </ng-container>
        
        <div class="footer">
          &copy; 2026 Ventror Group - Secure Enterprise Solutions
        </div>
      </div>
    </div>
  `,
  styles: [`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    :host {
      font-family: 'Inter', sans-serif;
      display: block;
      height: 100vh;
      background: #0f172a;
      overflow: hidden;
    }

    .login-container {
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }

    .login-card {
      width: 100%;
      max-width: 420px;
      padding: 3rem 2.5rem;
      text-align: center;
      z-index: 10;
      animation: fadeIn 0.8s ease-out;
      box-sizing: border-box;
    }

    .glass {
      background: rgba(30, 41, 59, 0.7);
      backdrop-filter: blur(20px);
      border: 1px solid rgba(255, 255, 255, 0.05);
      border-radius: 2rem;
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    }

    .logo {
      margin-bottom: 2rem;
      color: #38bdf8;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
    }

    .logo h1 {
      margin: 0;
      font-size: 2.5rem;
      font-weight: 800;
      color: #f8fafc;
      letter-spacing: -0.02em;
    }

    .subtitle {
      color: #94a3b8;
      line-height: 1.6;
      margin-bottom: 2.5rem;
    }

    .input-group {
      margin-bottom: 1rem;
      text-align: left;
    }

    .modern-input {
      width: 100%;
      box-sizing: border-box;
      padding: 0.875rem 1.125rem;
      background: rgba(15, 23, 42, 0.8);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 0.875rem;
      color: white;
      font-size: 0.95rem;
      font-family: 'Inter', sans-serif;
      transition: all 0.2s;
    }

    .modern-input:focus {
      outline: none;
      border-color: #38bdf8;
      background: rgba(15, 23, 42, 1);
      box-shadow: 0 0 0 4px rgba(56, 189, 248, 0.1);
    }

    .error-msg {
      color: #ef4444;
      font-size: 0.875rem;
      margin: 1rem 0;
    }

    .btn-primary {
      width: 100%;
      box-sizing: border-box;
      padding: 0.875rem;
      background: linear-gradient(135deg, #0ea5e9, #4f46e5);
      color: white;
      border: none;
      border-radius: 0.875rem;
      font-weight: 700;
      font-size: 0.95rem;
      font-family: 'Inter', sans-serif;
      cursor: pointer;
      transition: all 0.2s;
      letter-spacing: 0.01em;
    }

    .btn-primary:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 10px 15px -3px rgba(14, 165, 233, 0.4);
    }
    
    .btn-primary:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .btn-secondary {
      width: 100%;
      box-sizing: border-box;
      padding: 0.875rem;
      background: rgba(255, 255, 255, 0.05);
      color: #94a3b8;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 0.875rem;
      font-weight: 600;
      font-size: 0.95rem;
      font-family: 'Inter', sans-serif;
      cursor: pointer;
      transition: all 0.2s;
      margin-top: 0.5rem;
    }

    .btn-secondary:hover {
      background: rgba(255, 255, 255, 0.1);
      color: white;
    }

    .btn-text {
      background: none;
      border: none;
      color: #38bdf8;
      font-size: 0.875rem;
      font-weight: 600;
      cursor: pointer;
      margin-top: 1.5rem;
    }

    .divider {
      display: flex;
      align-items: center;
      margin: 1.5rem 0;
      color: #475569;
      font-size: 0.75rem;
      font-weight: 700;
      letter-spacing: 0.05em;
    }

    .divider::before, .divider::after {
      content: "";
      flex: 1;
      height: 1px;
      background: rgba(255, 255, 255, 0.1);
    }

    .divider span { margin: 0 1rem; }

    .qr-container {
      background: white;
      padding: 1rem;
      border-radius: 1.5rem;
      display: inline-block;
      margin: 0 auto;
      box-shadow: 0 10px 25px rgba(0,0,0,0.2);
    }

    .qr-img {
      display: block;
      width: 180px;
      height: 180px;
    }

    .success-msg {
      color: #10b981;
      font-size: 0.95rem;
      margin: 1.5rem 0;
      line-height: 1.5;
    }

    .footer {
      margin-top: 3rem;
      font-size: 0.75rem;
      color: #475569;
    }

    .fade-in { animation: fadeIn 0.5s ease-out; }
    .glow-orb { position: absolute; border-radius: 50%; filter: blur(80px); opacity: 0.4; }
    .orb-1 { top: 10%; left: 10%; width: 400px; height: 400px; background: #0ea5e9; }
    .orb-2 { bottom: 10%; right: 10%; width: 500px; height: 500px; background: #4f46e5; }

    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(10px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `]
})
export class LoginComponent implements OnInit {
  private authService = inject(AuthService);
  private userService = inject(UserService);
  private router = inject(Router);

  mode: 'login' | 'join' = 'login';
  
  // Login fields
  guid = '';
  email = '';
  code = '';
  error = '';

  // Join fields
  joinEmail = '';
  joinToken = '';
  joinCode = '';
  qrCode = '';
  loading = false;
  joinSuccess = '';

  ngOnInit() {
    this.email = this.authService.getLastEmail();
  }

  onLogin() {
    this.error = '';
    if (!this.guid) {
      this.error = 'Bitte Organisationstoken eingeben.';
      return;
    }
    if (!this.email) {
      this.error = 'Bitte E-Mail eingeben.';
      return;
    }

    this.loading = true;
    this.userService.login(this.email, this.guid, '').subscribe({
      next: (res) => {
        this.authService.login(this.guid, this.email, '');
        this.router.navigate(['/launcher']);
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Ungültige Zugangsdaten.';
        this.loading = false;
      }
    });
  }

  onJoin() {
    if (!this.joinEmail || !this.joinToken) {
      this.error = 'Bitte E-Mail und Token eingeben.';
      return;
    }
    this.loading = true;
    this.error = '';
    this.userService.joinOrganization(this.joinEmail, this.joinToken).subscribe({
      next: (res) => {
        this.qrCode = res.qrCode;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Fehler beim Beitritt. Bitte Token prüfen.';
        this.loading = false;
      }
    });
  }

  onVerifyJoin() {
    if (!this.joinCode) {
      this.error = 'Bitte 2FA Code eingeben.';
      return;
    }
    this.loading = true;
    this.error = '';
    this.userService.verifyJoin(this.joinEmail, this.joinToken, this.joinCode).subscribe({
      next: (res) => {
        if (res.status === 'ACTIVE') {
          this.joinSuccess = 'Erfolgreich! Sie sind Administrator. Sie können sich jetzt anmelden.';
        } else {
          this.joinSuccess = 'Anfrage gesendet! Bitte warten Sie auf die Freischaltung.';
        }
        this.loading = false;
        this.qrCode = '';
      },
      error: (err) => {
        this.error = err.error?.message || 'Falscher 2FA Code.';
        this.loading = false;
      }
    });
  }
}
